const BREAKPOINTS = {
  mobile: 0, // optional
  tablet: 640,
  laptop: 1024,
  desktop: 1280,
}

export function useDeviceBreakpoint(): ReturnType<typeof useBreakpoints<keyof typeof BREAKPOINTS>> {
  return useBreakpoints(BREAKPOINTS)
}
